<template>
  <div class="progress">
    <div class="coach-assignments">
      <div class="block-header">
        <div class="md-title">{{ badgesLabel }}</div>
      </div>
      <transition-group name="badges_card" class="badges-cards" tag="div">
        <md-card class="badges md-elevation-2 md-layout-item earned-badges"
          :key="badgeIndex"
          v-for="(badge, badgeIndex) in earned_badges"
        >
          <md-card-header>
            <md-card-expand>
              <div  class="md-layout">
                <div class="md-layout-item">
                  <div class="md-layout earned-badges-item-header">
                    <div class="badge-icon md-layout-item md-size-10 md-alignment-center-center completed">
                      <img v-if="badge.icon" :alt="badge.title" :src="badge.icon" />
                    </div>

                    <div class="md-layout-item md-size-70 badge-content">
                      <div>
                        <div class="md-margin-bt-10">
                          <div class="md-title">{{ badge.title }}</div>
                        </div>
                        <div class="awarded">
                          <span class="badge-label">Awarded to: </span>
                          <span>{{ learner }}</span>
                        </div>
                        <div class="issued_on">
                          <span class="badge-label">Issued on: </span>
                          <span>{{ badge.date }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="md-layout-item md-size-20 badge-download-button">
                      <div class="md-ripple md-disabled">
                        <md-button @click="downloadBadge(badge)" class="md-button md-raised md-primary md-theme-default" v-if="$mq == 'large' || $mq == 'xlarge'">
                          <span class="label">Download</span>
                          <i class="material-icons-outlined">
                            file_download
                          </i>
                        </md-button>
                        <md-button @click="downloadBadge(badge)" class="md-button" v-else>
                          <i class="material-icons-outlined">
                            file_download
                          </i>
                        </md-button>
                      </div>
                    </div>
                  </div>

                  <md-card-expand-trigger v-if="badge.badge_class">
                    <md-button class="view-more" @keydown.enter="badgeOpen(badge.id, !expandedBadges[badge.id])">View details</md-button>
                  </md-card-expand-trigger>
                  <md-button v-else class="view-more view-certificate" @click="viewCertificate(badge)">View</md-button>
                </div>
              </div>
              <div class="md-layout" v-if="badge.badge_class">
                <md-card-expand-content>
                  <md-card-content>
                    <div class="description md-layout">
                      <span class="badge-label md-layout-item md-size-10 md-small-size-100"><b>Description:</b></span>
                      <span class="badge-value md-layout-item md-size-90 md-small-size-100" v-html="markdownFilter(badge.description)"></span>
                    </div>
                    <div class="criteria md-layout">
                      <span class="badge-label md-layout-item md-size-10 md-small-size-100"><b>Criteria:</b></span>
                      <span class="badge-value md-layout-item md-size-90 md-small-size-100" v-html="markdownFilter(badge.criteria)"></span>
                    </div>
                    <md-card-expand-trigger>
                      <md-button :tabindex="expandedBadges[badge.id] ? 0 : -1" @keydown.enter="badgeOpen(badge.id, !expandedBadges[badge.id])" class="view-less">View less</md-button>
                    </md-card-expand-trigger>
                  </md-card-content>
                </md-card-expand-content>
              </div>
            </md-card-expand>
          </md-card-header>
        </md-card>
        <md-card
          class="badges md-elevation-2 md-layout-item"
          :key="badgeIndex"
          v-for="(badge, badgeIndex) in badges_filtered"
        >
          <md-card-header>
            <md-card-expand >
              <div  class="md-layout">
                <div class="md-layout-item">
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <div class="md-layout-item md-margin-bt-15">
                        <div class="md-title">{{ badge.title }}</div>
                      </div>
                      <div class="md-layout md-margin-bt-15">
                        <div class="md-layout md-alignment-center-center">
                          <svg class="line-progress" height="17" width="100%">
                            <g class="progress-container">
                              <line x1="0" y1="0" x2="100%" y2="100%" stroke-width="30" />
                            </g>
                            <g class="progress-content">
                              <line
                                x1="0"
                                y1="0"
                                :x2="badge.progress"
                                y2="0"
                                stroke="#457B9D"
                                fill="transparent"
                                :stroke-dashoffset="badge.progress"
                                stroke-width="34"
                              />
                            </g>
                          </svg>
                        </div>
                        <div class="md-layout-item md-size-30 md-small-size-50">
                          <span
                            class="progress-text"
                          >{{ badge.completed_activities }}/{{ badge.total_activities }} completed</span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="badge-icon md-layout md-size-20 md-alignment-center-center"
                      :class="{ completed: badge.completed }"
                    >
                      <img :alt="badge.title" :src="badge.icon" />
                    </div>
                  </div>
                  <md-card-expand-trigger>
                    <md-button class="view-more" @keydown.enter="badgeOpen(badge.id, !expandedBadges[badge.id])">View details</md-button>
                  </md-card-expand-trigger>
                </div>
              </div>
              <div class="md-layout">
                <md-card-expand-content>
                  <md-card-content>
                    <div
                      class="badge-activities md-layout-item"
                      :key="index"
                      v-for="(item, index) in badge.activities"
                    >
                      <div
                        :tabindex="expandedBadges[badge.id] ? 0 : -1"
                        v-on:keyup.13="goTo(item.id)"
                        class="md-layout">
                        <div class="placeholder md-layout-item md-size-5">
                          <div class="badge-placeholder" :class="{ completed: item.completed }"></div>
                        </div>
                        <div class="md-layout-item">
                          <div @click="goTo(item.id)" class="md-title submission">
                            {{item.title }}
                          </div>
                          <div class="completed-date" v-if="item.date != ''">
                            Date completed:
                            {{ item.date }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <md-card-expand-trigger>
                      <md-button :tabindex="expandedBadges[badge.id] ? 0 : -1" @keydown.enter="badgeOpen(badge.id, !expandedBadges[badge.id])" class="view-less">View less</md-button>
                    </md-card-expand-trigger>
                  </md-card-content>
                </md-card-expand-content>
              </div>
            </md-card-expand>
          </md-card-header>
        </md-card>
      </transition-group>
      <div v-if="badges && badges.length > min_count_badges" class="fb-text-center">
        <md-button class="latest-activity-show all-less-btn" @click="filtered = !filtered">
          <span tabindex="0" v-if="filtered">Show all</span>
          <span tabindex="0" v-else>Show less</span>
        </md-button>
      </div>
    </div>
    <learner-observation-list></learner-observation-list>
    <learner-assignment-list></learner-assignment-list>
  </div>
</template>

<script>
import LearnerAssignmentList from "./components/LearnerAssignmentList";
import LearnerObservationList from "./components/LearnerObservationList";
import Vue from "vue";
import { marked } from "marked";

export default {
  name: "TeacherDashboard",
  components: {
    LearnerAssignmentList,
    LearnerObservationList,
  },
  computed: {
    badges_filtered() {
      if (this.filtered && this.badges) {
        return this.badges.slice(0, this.min_count_badges);
      }
      return this.badges;
    },
  },

  mounted() {
    this.activities = window.drupalSettings.controller
      ? window.drupalSettings.controller.activities
      : [];
    this.badges = window.drupalSettings.controller
      ? window.drupalSettings.controller.badges
      : [];
    this.all_activity = window.drupalSettings.controller
      ? window.drupalSettings.controller.all_activity
      : [];
    this.badges.forEach((badge) => {
      this.expandedBadges[badge.id] = false;
    });
    this.earned_badges = window.drupalSettings.controller
      ? window.drupalSettings.controller.earned_badges
      : [];
    this.learner = window.drupalSettings.user.first_name + ' ' + window.drupalSettings.user.last_name

  },

  data() {
    return {
      activities: [],
      badges: [],
      all_activity: [],
      filtered: true,
      min_count_badges: 3,
      badgesLabel: window.drupalSettings.group_catch_config.labels.badges_label || "Badges",
      expandedBadges: []
    };
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    badgeOpen(id, value) {
      Vue.set(this.expandedBadges, id, value);
    },
    downloadBadge(badge) {
      if (badge.badge_class) {
        window.open("/assertion/" + badge.id, "_blank");
      }
      else {
        window.location.href = "/certificate-download/" + badge.id;
      }
    },
    viewCertificate(certificate) {
      window.open("/certificates/" + certificate.id, "_blank");
    },
    goTo(nodeId) {
      window.location.href = "/node/" + nodeId;
    },
    markdownFilter(text) {
      return marked(text);
    }
  },
};
</script>
